import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const Home = () => {
  const { t } = useTranslation('home');
  const { language } = useLanguage();

  return (
    <div className="home-page">
      <SEO 
        title="Malaysia Top AI Software Company | Enterprise AI Solutions"
        description="EWANDS is Malaysia's leading AI software company specializing in AI governance, predictive analytics, and enterprise AI solutions. We build governed, enterprise-ready AI systems tailored for businesses across Malaysia and ASEAN."
        keywords="Malaysia top AI software company, AI company Malaysia, AI governance Malaysia, AI predictive analytics, enterprise AI solutions Malaysia, software development company Malaysia, custom AI systems, AI technology Malaysia, ASEAN AI solutions"
        canonicalPath={`/${language}`}
        ogImage="/Images/logo.png"
      />
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <div className="gradient-layer"></div>
          <div className="particle-layer"></div>
          <div className="grid-overlay"></div>
          <div className="tech-lines"></div>
        </div>
        
        <div className="hero-content">
          <div className="container">
            <div className="hero-wrapper">
              {/* Tech decorative elements */}
              <div className="tech-element tech-element-1"></div>
              <div className="tech-element tech-element-2"></div>
              <div className="tech-element tech-element-4"></div>
              <Link to={`/${language}/capabilities`} className="tech-element tech-element-3 tech-interactive-dot"></Link>
              
              <h1 className="hero-quote">
                <span className="quote-highlight">{t('hero.title')}</span><br />
                {t('hero.subtitle1')}<br />
                {t('hero.subtitle2')}
              </h1>
              
              <Link to={`/${language}/capabilities`} className="hero-cta">
                <span className="cta-text-long">{t('hero.ctaLong')}</span>&nbsp; {t('hero.cta')}
                <span className="cta-chevrons">
                  <span>›</span><span>›</span><span>›</span>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
